import axios from 'axios';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { onAxiosResponse } from 'data_system/token_auth/utils';

import { rootReducer as reducer } from 'data_system/resource_portal/reducers/rootReducer';
import rootSaga from 'data_system/resource_portal/sagas/root';

import { history } from './history';

const sagaMiddleware = createSagaMiddleware();

// create a redux store with our reducer above and middleware
// Redux devtools version
const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
const composeEnhancers = devTools
  ? devTools({ name: 'Resource Portal' })
  : compose;
export const store = createStore(
  reducer(history),
  composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware))
);

const responseInterceptor = [
  (response) => {
    onAxiosResponse(response, store);
    return Promise.resolve(response);
  },
  (error) => {
    onAxiosResponse(error.response, store);
    return Promise.reject(error);
  },
];

axios.interceptors.response.use(...responseInterceptor);

// run the saga
sagaMiddleware.run(rootSaga);
